import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Svg, Path, Text as SvgText } from 'react-native-svg';

const Logo = ({ width = 240, height = 60 }) => {
  return (
    <View style={styles.container}>
      <Svg width={width} height={height} viewBox="0 0 240 60">
        <Path d="M30 12C20.059 12 12 20.059 12 30C12 39.941 20.059 48 30 48C39.941 48 48 39.941 48 30C48 20.059 39.941 12 30 12Z" fill="#3498DB"/>
        <Path d="M30 15.6C22.048 15.6 15.6 22.048 15.6 30C15.6 37.952 22.048 44.4 30 44.4C37.952 44.4 44.4 37.952 44.4 30C44.4 22.048 37.952 15.6 30 15.6Z" fill="#2C3E50"/>
        <Path d="M30 19.2C24.035 19.2 19.2 24.035 19.2 30C19.2 35.965 24.035 40.8 30 40.8C35.965 40.8 40.8 35.965 40.8 30C40.8 24.035 35.965 19.2 30 19.2Z" fill="#3498DB"/>
        <Path d="M30 22.8C26.023 22.8 22.8 26.023 22.8 30C22.8 33.977 26.023 37.2 30 37.2C33.977 37.2 37.2 33.977 37.2 30C37.2 26.023 33.977 22.8 30 22.8Z" fill="#2C3E50"/>
        <SvgText x="55" y="36" fontFamily="Arial" fontSize="22" fontWeight="bold" fill="#FFFFFF">A Mission Hub</SvgText>
        <Path d="M30 12L39.6 7.2L48 12" stroke="#3498DB" strokeWidth="1.8"/>
        <Path d="M30 12L20.4 7.2L12 12" stroke="#3498DB" strokeWidth="1.8"/>
      </Svg>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default Logo;